import React, { Fragment } from "react";
import "./styles.css";

export default function IndicadorDeCarga(props) {
  return (
    <Fragment>
      {props.open ? (
        <Fragment>
          <div id="overlay" className="overlay">
            <div className="loadingio-spinner-eclipse-q0rfudicgan">
              <div className="ldio-32tyvfdrsnu">
                <div></div>
              </div>
            </div>
            <div className="loadingSpinnerText">{props.message ? (props.message) : ("Cargando...")}</div>
          </div>
        </Fragment>
      ) : (
        <Fragment></Fragment>
      )}
    </Fragment>
  );
}
